import { render, staticRenderFns } from "./ApplyRemoveTag.vue?vue&type=template&id=3d475c9c&scoped=true"
import script from "./ApplyRemoveTag.vue?vue&type=script&lang=js"
export * from "./ApplyRemoveTag.vue?vue&type=script&lang=js"
import style0 from "./ApplyRemoveTag.vue?vue&type=style&index=0&id=3d475c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d475c9c",
  null
  
)

export default component.exports